import { Injectable } from '@angular/core';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  titleWiseVideo: any[] = [];
  titleWiseVideoChange = new BehaviorSubject<any[]>([]);
  titleWiseVideoList: AngularFireList<any>;



  gotTitleWiseVideo: boolean = false;
  sub: Subscription;
  constructor(private firebase: AngularFireDatabase) {}

  getTitleWiseVideoList(title) {
    this.resetTitleWiseVideo();
    if (!this.gotTitleWiseVideo) {
      
        this.titleWiseVideoList = this.firebase.list('video', (ref) =>
          ref.orderByChild('category').equalTo(title)
        );
      
      this.gotTitleWiseVideo = true;
    }
    this.setTitleWiseVideo(title);
  }

  resetTitleWiseVideo() {
    this.gotTitleWiseVideo = false; // Reset the flag
    this.titleWiseVideo = []; // Clear previous events
    this.titleWiseVideoChange.next(this.titleWiseVideo); // Notify subscribers about the reset
  }

  setTitleWiseVideo(title) {
    let videoListRef = this.titleWiseVideoList;
    videoListRef.snapshotChanges().subscribe((list) => {
      let videos = list.map((item) => {
        const data = item.payload.val();
        const videoUrl = data.url;

        let videoId = this.getYouTubeVideoId(videoUrl);
        let dataSrc = '';

        if (videoUrl.includes('shorts')) {
          dataSrc = `https://www.youtube.com/embed/${videoId}`;
        } else {
          dataSrc = `https://www.youtube.com/watch?v=${videoId}`;
        }

        return {
          $key: item.key,
          ...data,
          dataSrc,
        };
      });
      
        this.titleWiseVideo = [...videos].reverse();
        this.titleWiseVideoChange.next(this.titleWiseVideo);
      
    });
  }

  getTitleWiseVideo() {
    this.titleWiseVideoChange.next(this.titleWiseVideo);
  }

  getYouTubeVideoId(url: string): string | null {
    const videoMatch = url.match(/(?:v=|\/embed\/|\/watch\?v=|youtu\.be\/|\/shorts\/|\/v\/)([^&?/]+)/);
    return videoMatch ? videoMatch[1] : null;
  }
}
